import { type RootState } from '@/store';

export const user = ({ user: { user } }: RootState) => user;
